var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-chart-wrapper"},[_c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"pie","height":_vm.height,"options":_vm.chartOptions,"series":_vm.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }